import axios from "axios";
//import { toast } from "react-toastify";
import { toastManager } from "./toastManager";
const tokenKey = "token2";
const tokenKeyRefresh = "tokenCrm2Refresh"
const cardKey = "card";
const loginPath = "/Login"
const googleToken = 'googleToken2';


function getLocalJwtRefresh() {
    return localStorage.getItem(tokenKeyRefresh);
}

function setLocalJwtRefresh(jwt) {
    localStorage.setItem(tokenKeyRefresh, jwt);
}

const handleChange = (event, form, setForm) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    setForm({ ...form, [name]: value });
};




function setJwt(jwt) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;
}

function goLogin() {
    window.location = loginPath;
}

// ---------------------------
// Request Interceptor
// ---------------------------
axios.interceptors.request.use(
    config => {
        // اگر درخواست AllowAnonymous داشت، JWT اضافه نکن
        if (config.headers["AllowAnonymous"]) {
            delete config.headers["Authorization"];
            delete config.headers["AllowAnonymous"];
            return config;
        } 
        // اضافه کردن JWT
        const token = getLocalJwt();
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    error => Promise.reject(error)
);

// ---------------------------
// Response Interceptor
// ---------------------------

axios.interceptors.response.use((response) => {
    const { data } = response;
    console.log("axios data", data);
    return response;
}, error => {
    console.log("Error", error);
    /*const expectedError =
        error.response && error.response.status &&
        error.response.status >= 400 &&
        error.response.status < 500;*/
    if (error.response && error.response.status && error.response.status == 401) {
        logout();
        //    toast.error("حساب شما منقضی شده است مجددد وارد شوید", { theme: "colored" });
        toastManager.add("حساب شما منقضی شده است مجددد وارد شوید", "error", 5000)
        //goLogin();
        return Promise.reject(error);
    }
    //toast.error("خطا در ارتباط سرور", { theme: "colored" });
    toastManager.add('خطا در  اطلاعات', "error", 5000)
    return Promise.reject(error);
});


//--------

function getGoogleToken() {
    return localStorage.getItem(googleToken);
}

function setGoogleToken(jwt) {
    localStorage.setItem(googleToken, jwt);
}

//----------------------
function getLocalJwt() {
    return localStorage.getItem(tokenKey);
}


function setLocalJwt(jwt) {
    localStorage.setItem(tokenKey, jwt);
}
function logout() {
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(tokenKeyRefresh);
}

//------
function getCard() {
    const tempCard = localStorage.getItem(cardKey);
    let card = tempCard != null && tempCard != "" ? JSON.parse(tempCard) : [];
    return card;
}

function saveCard(data) {
    localStorage.setItem(cardKey, JSON.stringify(data));
}

function addSaveCard(card) {
    let tempCard = localStorage.getItem(cardKey);
    //console.log('1', tempCard);
    //console.log('2', tempCard != null && tempCard != "" ? "**" : "*");
    let oldCard = tempCard != null && tempCard != "" ? JSON.parse(tempCard) : [];
    console.log('oldCard', oldCard);
    let newCard = oldCard == null ? [...card] : [...oldCard, ...card];
    console.log('newCard', newCard);
    saveCard(newCard);
    //console.log(localStorage.getItem('card'));
}

function deleteCard(id) {
    let tempCard = localStorage.getItem(cardKey);

    let oldCard = tempCard != null && tempCard != "" ? JSON.parse(tempCard) : [];
    if (oldCard == [])
        return;

    console.log('oldCard', oldCard);
    let article = oldCard.find(m => m.id === id);
    oldCard.splice(oldCard.indexOf(article), 1);

    console.log('article', article);
    console.log('oldCard', oldCard);
    saveCard(oldCard);
    return article;
}

function emptyCard() {
    localStorage.removeItem(cardKey);
}


function getGeolocation(showError, onGet) {
    navigator.geolocation.getCurrentPosition((position) => {
        console.log("position:", position);
        onGet(position);

    }, (error) => {
        if (showError)
            toastManager.add('جهت دسترسی به موقغیت یاب سرور شما به ارتباط امن https متصل نیست', "error", 5000)
        // toast.error('جهت دسترسی به موقغیت یاب سرور شما به ارتباط امن https متصل نیست' + + error.message);
        console.error("Error 111 = " + error.code + " - " + error.message);
    });
}

function onErrorImage(ev) {
    //console.log('onerror');
    ev.target.src = '/images/defaultArticle.png'
}

function onLoadImage(ev) {
    //console.log('onLoadImage');
    //ev.target.src = '/images/defaultArticle.png';
    //console.log(ev);
    //ev.onLoad=null;
}


export default {
    setGoogleToken, getGoogleToken,
    //disableError401,
    //enableError401,

    onErrorImage,
    onLoadImage,

    getGeolocation,
    handleChange,

    logout,
    getLocalJwt,
    setLocalJwt,
    setLocalJwtRefresh, getLocalJwtRefresh,
    goLogin,



    getCard,
    addSaveCard,
    saveCard,
    emptyCard,
    deleteCard,

    axiosInstance: axios,
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    setJwt
};
